module.exports = __webpack_public_path__ + "static/media/bicycle_3_complete_wheel.32f89125.png";